import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesService {
  private hasUnsavedChanges = false;
  private requestConfirmSubject = new Subject<void>();
  private resolvePendingConfirm: ((result: boolean) => void) | null = null;

  setUnsavedChanges(status: boolean): void {
    this.hasUnsavedChanges = status;
  }

  getHasUnsavedChanges(): boolean {
    return this.hasUnsavedChanges;
  }

  /**
   * Pausa la ejecución y solicita confirmación si hay cambios pendientes.
   * @returns Promesa que resuelve a `true` (Continuar) o `false` (Regresar).
   */
  async canDeactivateAsync(): Promise<boolean> {
    if (!this.hasUnsavedChanges) {
      return true;
    }
    
    return new Promise<boolean>((resolve) => {
      this.resolvePendingConfirm = resolve;
      this.requestConfirmSubject.next();
    });
  }

  get requestConfirm$(): Observable<void> {
    return this.requestConfirmSubject.asObservable();
  }

  resolveConfirm(result: boolean): void {
    if (this.resolvePendingConfirm) {
      this.resolvePendingConfirm(result);
      this.resolvePendingConfirm = null;
    }
    if (result) {
      // Si el usuario confirma salir, descartamos los cambios
      this.hasUnsavedChanges = false;
    }
  }
}
